export default __webpack_public_path__ + "static/media/terra.52c58788.svg";